// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Value from "../Data.Value/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Value.eqValue);
var AddressExtraIsSymbol = {
    reflectSymbol: function () {
        return "AddressExtra";
    }
};
var AddressExtra = function (x) {
    return x;
};
var toFillFormTypeAddressExtr = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeAddressExtra_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqAddressExtra = {
    eq: function (x) {
        return function (y) {
            return eq(x)(y);
        };
    }
};
var genericAddressExtra = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showAddressExtra = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAddressExtra)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Value.showValue))(AddressExtraIsSymbol))
};
var unscrambleDecodeAddressExtra = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericAddressExtra)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_Value.udecodeValue)))(Unscramble_Generic.defaultOptions)
};
var encodeAddressExtra = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericAddressExtra)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(AddressExtraIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Value.encodeValue))))
};
var decodeAddressExtra = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericAddressExtra)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(AddressExtraIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Value.decodeValue)))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    AddressExtra,
    genericAddressExtra,
    eqAddressExtra,
    showAddressExtra,
    encodeAddressExtra,
    decodeAddressExtra,
    unscrambleDecodeAddressExtra,
    toFillFormTypeAddressExtr,
    newtypeAddressExtra_
};
